var map = {
	"./afb-color.svg": 645,
	"./alb-color.svg": 646,
	"./all.svg": 647,
	"./amb-color.svg": 648,
	"./arg.svg": 649,
	"./aus.svg": 650,
	"./bank-icon.svg": 651,
	"./bankdemo-color.svg": 652,
	"./bel.svg": 653,
	"./bimb-color.svg": 654,
	"./bkr-color.svg": 655,
	"./bpay-color.svg": 656,
	"./bra.svg": 657,
	"./bsn-color.svg": 658,
	"./can.svg": 659,
	"./checked-green.png": 660,
	"./checked-white.png": 661,
	"./cimb-color.svg": 662,
	"./cimb-icon.svg": 663,
	"./citi-color.svg": 664,
	"./cmr.svg": 665,
	"./crc.svg": 666,
	"./cro.svg": 667,
	"./den.svg": 668,
	"./ecu.svg": 669,
	"./eng.svg": 670,
	"./esp.svg": 671,
	"./fav-blue.svg": 672,
	"./fav-gray.png": 673,
	"./fav-gray.svg": 674,
	"./fav-icon-active.png": 675,
	"./fav-icon.png": 676,
	"./fav-red.png": 677,
	"./fra.svg": 678,
	"./game-icon.svg": 679,
	"./games-active-m.svg": 680,
	"./ger.svg": 681,
	"./gha.svg": 682,
	"./gxbank-color.svg": 683,
	"./hlb-color.svg": 684,
	"./hlb-icon.svg": 685,
	"./hsbc-color.svg": 686,
	"./irn.svg": 687,
	"./jpn.svg": 688,
	"./kor.svg": 689,
	"./ksa.svg": 690,
	"./kwh-color.svg": 691,
	"./latest-icon-active.png": 692,
	"./latest-icon.png": 693,
	"./lc-active-m.svg": 694,
	"./lc-icon.svg": 695,
	"./lottery-active-m.svg": 696,
	"./lottery-icon.svg": 697,
	"./lottery-m.svg": 698,
	"./love.svg": 699,
	"./mar.svg": 700,
	"./mbb-color.svg": 701,
	"./mex.svg": 702,
	"./ned.svg": 703,
	"./ocbc-color.svg": 704,
	"./ocbc-icon.svg": 705,
	"./p2p-active-m.svg": 706,
	"./p2p-icon.svg": 707,
	"./p2p-m.svg": 708,
	"./pbb-color.svg": 709,
	"./pol.svg": 710,
	"./por.svg": 711,
	"./price-high.svg": 712,
	"./price-low.svg": 713,
	"./qat.svg": 714,
	"./rhb-color.svg": 715,
	"./rhb-icon.svg": 716,
	"./scb-color.svg": 717,
	"./sen.svg": 718,
	"./slot-active-m.svg": 719,
	"./slot-icon.svg": 720,
	"./sport-active-m.svg": 721,
	"./sports-icon.svg": 722,
	"./srb.svg": 723,
	"./star.svg": 724,
	"./sui.svg": 725,
	"./tng-color.svg": 726,
	"./trx-icon.svg": 727,
	"./trx.svg": 728,
	"./tun.svg": 729,
	"./uob-color.svg": 730,
	"./uru.svg": 731,
	"./usa.svg": 732,
	"./usdc.svg": 733,
	"./usdt.svg": 734,
	"./ustd-icon.svg": 735,
	"./wal.svg": 736,
	"./x33-logo-b.svg": 737,
	"./x33-square-icon.svg": 738
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 110;